import { Component, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { InspirationRoomService } from '../../canvas/services/inspiration-rooms/inspiration-room.service';
import { OptionSelectorService } from '../../canvas/services/option-selector.service';
import { Appointment, Option} from '../../engine/models/models';
import { Globals } from '../../services/globals';

@Component({
  selector: 'appointment-details.component',
  templateUrl: 'appointment-details.component.html',
})
export class AppointmentDetailsComponent {
  appointment: Appointment;
  
  loadSchema: EventEmitter<any> = new EventEmitter();
  optionJson: string;

  constructor(public globals: Globals,
   
    private inspirationRoomService: InspirationRoomService,
    private router: Router,
    private service: OptionSelectorService) {
    if (globals.selectedOption) {
      this.optionJson = this.getSelectedObjectJson();
    }
    

  }
  onSchemaLoad() {
    return this.loadSchema;
   // this.isClientAccess=this.globals.isClientLoginBlocked;
  }

  forceRefresh() {
    this.globals.engine = null;
    this.globals.validateSession(true);
  }

  getSelectedObjectJson(): string {
    const getCircularReplacer = () => {
      const seen = new WeakSet()
      return (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return
          }
          seen.add(value)
        }
        return value
      }
    }

    let json = JSON.parse(JSON.stringify(this.globals.selectedOption, getCircularReplacer()));
    return json;
  }

}
